(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.MainController = (function(superClass) {
    extend(MainController, superClass);

    function MainController(scope, transitions, rootScope, state, session, timeout, interval, http, navigationAssistantService) {
      this.scope = scope;
      this.transitions = transitions;
      this.rootScope = rootScope;
      this.state = state;
      this.session = session;
      this.timeout = timeout;
      this.interval = interval;
      this.http = http;
      this.navigationAssistantService = navigationAssistantService;
      this.registerClick = bind(this.registerClick, this);
      this.startCountdownTimer = bind(this.startCountdownTimer, this);
      this.refreshSecondsUntilLogout = bind(this.refreshSecondsUntilLogout, this);
      MainController.__super__.constructor.apply(this, arguments);
      this.rootScope.$on('unauthorized', (function(_this) {
        return function() {
          _this.session.remove('Authorization');
          _this.session.remove('OriginalUser');
          return _this.state.go('login');
        };
      })(this));
      this.scope.sessionLifetimeMinutes = null;
      this.scope.sessionAlmostEndingMessageMinutes = 15;
      this.scope.bs2ContainerElement = document.getElementById('bs2-container');
      this.refreshTokenMinutes = 1;
      this.timeLeftCalculationIntervalSeconds = 5;
      this.interval(this.refreshSecondsUntilLogout, this.timeLeftCalculationIntervalSeconds * 1000);
      this.logoutTimer = null;
      this.scope.registerClick = this.registerClick;
      if (this.session.get('Authorization')) {
        this.registerClick();
      }
      window.rootScope = this.rootScope;
      this.rootScope.transitions = [];
      this.rootScope.isTransitioning = (function(_this) {
        return function() {
          return _this.rootScope.transitions.length > 0;
        };
      })(this);
      this.transitions.onStart(null, (function(_this) {
        return function(trans) {
          return _this.rootScope.transitions.push(trans);
        };
      })(this));
      this.transitions.onSuccess(null, (function(_this) {
        return function(trans) {
          var ref, ref1;
          _this.navigationAssistantService.angularJSStateChange((ref = trans.to()) != null ? ref.name : void 0, (ref1 = trans.from()) != null ? ref1.name : void 0);
          return _this.rootScope.transitions.pop();
        };
      })(this));
    }

    MainController.prototype.refreshSecondsUntilLogout = function() {
      this.scope.secondsUntilLogout = parseInt(this.scope.sessionLifetimeMinutes * 60 - (new Date().getTime() - this.session.get('AuthTime')) / 1000 - this.timeLeftCalculationIntervalSeconds);
      this.scope.minutesUntilLogout = parseInt(this.scope.secondsUntilLogout / 60);
      if (this.scope.secondsUntilLogout > 0 && !this.logoutTimer) {
        return this.startCountdownTimer();
      }
    };

    MainController.prototype.startCountdownTimer = function() {
      var milliseconds;
      if (this.logoutTimer != null) {
        this.timeout.cancel(this.logoutTimer);
      }
      milliseconds = Math.min(this.scope.secondsUntilLogout * 1000, 2147483647);
      return this.logoutTimer = this.timeout((function(_this) {
        return function() {
          _this.state.go('logout');
          return _this.logoutTimer = null;
        };
      })(this), milliseconds);
    };

    MainController.prototype.registerClick = function() {
      if (!this.session.get('Authorization')) {
        return;
      }
      if (new Date().getTime() - this.session.get('AuthTime') > this.refreshTokenMinutes * 60 * 1000) {
        return this.http.get((Config.get('api_url')) + "/refreshed-tokens").then((function(_this) {
          return function(response) {
            if (_this.state.current.name === 'context-dependent-registration') {
              return;
            }
            _this.session.set('AuthTime', new Date().getTime());
            _this.refreshSecondsUntilLogout();
            if (_this.state.current.name === 'logout') {
              return;
            }
            _this.session.set('Authorization', "Bearer " + response.data.userToken);
            _this.session.set('SafeLink', "Bearer " + response.data.safeLinkToken);
            _this.session.set('OriginalUser', "Bearer " + response.data.originalUserToken);
            _this.startCountdownTimer();
            return true;
          };
        })(this))["catch"]((function(_this) {
          return function(error) {
            _this.session.remove('Authorization');
            _this.session.remove('SafeLink');
            _this.session.remove('OriginalUser');
            return _this.state.go('login');
          };
        })(this));
      }
    };

    return MainController;

  })(Controller);

}).call(this);
